//Lib
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

//Reducer
import apiSlice from '@app/slice/apiSlice';
import { ownerApiSlice } from '@app/slice/ownerApiSlice';
import { reportsApiSlice } from '@app/slice/reportsApiSlice';

const initReducer = {
  [apiSlice.reducerPath]: apiSlice.reducer,
  [ownerApiSlice.reducerPath]: ownerApiSlice.reducer,
  [reportsApiSlice.reducerPath]: reportsApiSlice.reducer,
};
const store = configureStore({
  reducer: initReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(apiSlice.middleware)
      .concat(ownerApiSlice.middleware)
      .concat(reportsApiSlice.middleware),
});

setupListeners(store.dispatch);

export default store;
